import { render, staticRenderFns } from "./TagRow.vue?vue&type=template&id=efd4794c"
import script from "./TagRow.vue?vue&type=script&lang=ts"
export * from "./TagRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd4794c')) {
      api.createRecord('efd4794c', component.options)
    } else {
      api.reload('efd4794c', component.options)
    }
    module.hot.accept("./TagRow.vue?vue&type=template&id=efd4794c", function () {
      api.rerender('efd4794c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/tags/TagRow.vue"
export default component.exports